module.exports = __webpack_public_path__ + "img/jituan1.0bbd18e6.png";